(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
	class StickyHeader extends HTMLElement {
	constructor() {
	super();
	}

	connectedCallback() {
	this.header = document.querySelector('.shopify-section-header');
	this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
	this.headerBounds = {};
	this.currentScrollTop = 0;
	this.preventReveal = false;

	if (this.headerIsAlwaysSticky) {
	this.header.classList.add('shopify-section-header-sticky');
	this.header.classList.add('always-fixed');
	};

	this.onScrollHandler = this.onScroll.bind(this);
	this.hideHeaderOnScrollUp = () => this.preventReveal = true;
	this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
	window.addEventListener('scroll', this.onScrollHandler, false);

	this.createObserver();
	}

	disconnectedCallback() {
	this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
	window.removeEventListener('scroll', this.onScrollHandler);
	}

	createObserver() {
	let observer = new IntersectionObserver((entries, observer) => {
	this.headerBounds = entries[0].intersectionRect;
	observer.disconnect();
	});

	observer.observe(this.header);
	}

	onScroll() {
	const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

	if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
	if (this.preventHide) return;
	requestAnimationFrame(this.hide.bind(this));
	} else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
	// The scroll offset value when opening a modal window 14px.
	// This prevents the header menu from appearing when modal windows are opened.
	if (!this.preventReveal && this.currentScrollTop - scrollTop != 14) {
	requestAnimationFrame(this.reveal.bind(this));
	}else {
	window.clearTimeout(this.isScrolling);

	this.isScrolling = setTimeout(() => {
	this.preventReveal = false;
	}, 66);

	requestAnimationFrame(this.hide.bind(this));
	}
	} else if (scrollTop <= this.headerBounds.top) {
	requestAnimationFrame(this.reset.bind(this));
	}

	this.currentScrollTop = scrollTop;
	}

	hide() {
	if (this.headerIsAlwaysSticky) return;
	this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
	this.closeMenuDisclosure();
	}

	reveal() {
	if (this.headerIsAlwaysSticky) return;
	this.header.classList.add('shopify-section-header-sticky', 'animate');
	this.header.classList.remove('shopify-section-header-hidden');
	}

	reset() {
	if (this.headerIsAlwaysSticky) return;
	this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
	}

	closeMenuDisclosure() {
	this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
	this.disclosures.forEach(disclosure => disclosure.close());
	}

	}

	customElements.define('sticky-header', StickyHeader);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lb-shop-the-look"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lb-shop-the-look')) {
    customElements.define('lb-shop-the-look', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) {
          if (this.resizeObserver && this.grid) this.resizeObserver.observe(this.grid);
          if (this.grid && this.onGridScroll) this.grid.addEventListener('scroll', this.onGridScroll, { passive: true });
          this.updateNavigation();
          return;
        }
        this.ready = true;
        this.dialog = this.querySelector('dialog');
        this.content = this.querySelector('[data-look-content]');
        this.strings = JSON.parse(this.querySelector('[data-look-strings]').textContent);
        this.money = new Intl.NumberFormat(this.dataset.locale || 'uk', { style: 'currency', currency: this.dataset.currency || 'UAH', minimumFractionDigits: 0, maximumFractionDigits: 2 });
        this.classList.add('is-enhanced');
        this.grid = this.querySelector('.lb-looks__grid');
        this.cards = Array.from(this.grid.querySelectorAll('.lb-looks__card'));
        this.nav = this.querySelector('[data-look-navigation]');
        if (this.nav) {
          this.onGridScroll = () => {
            cancelAnimationFrame(this.navFrame);
            this.navFrame = requestAnimationFrame(() => this.updateNavigation());
          };
          this.grid.addEventListener('scroll', this.onGridScroll, { passive: true });
          this.resizeObserver = new ResizeObserver(() => this.updateNavigation());
          this.resizeObserver.observe(this.grid);
          this.updateNavigation();
        }
        this.addEventListener('click', event => {
          const navigation = event.target.closest('[data-look-nav]');
          if (navigation) this.moveLook(Number(navigation.dataset.lookNav));
          const opener = event.target.closest('[data-look-open]');
          if (opener) this.openLook(opener);
          if (event.target.closest('.lb-looks__close')) this.dialog.close();
        });
        this.dialog.addEventListener('click', event => { if (event.target === this.dialog) this.dialog.close(); });
        this.dialog.addEventListener('close', () => {
          document.body.classList.remove('lb-look-open');
          if (this.controller) this.controller.abort();
          if (this.trigger && this.trigger.isConnected) this.trigger.focus({ preventScroll: true });
        });
        this.addEventListener('change', event => {
          if (event.target.matches('[data-look-size]')) event.target.removeAttribute('aria-invalid');
          if (event.target.matches('[data-look-size],[data-look-include]')) {
            const message = this.content.querySelector('[data-look-status]').textContent;
            if (message === this.strings.chooseSizes || message === this.strings.chooseItems) this.status('');
            this.updateTotal();
          }
        });
        this.addEventListener('submit', event => { if (event.target.matches('.lb-looks__form')) this.addItems(event); });
      }
      disconnectedCallback() {
        if (this.resizeObserver) this.resizeObserver.disconnect();
        if (this.grid && this.onGridScroll) this.grid.removeEventListener('scroll', this.onGridScroll);
        cancelAnimationFrame(this.navFrame);
        if (this.controller) this.controller.abort();
        if (this.dialog && this.dialog.open) this.dialog.close();
        document.body.classList.remove('lb-look-open');
      }
      updateNavigation() {
        if (!this.nav || !this.cards.length) return;
        const max = this.grid.scrollWidth - this.grid.clientWidth;
        this.nav.hidden = max < 2;
        const bounds = this.grid.getBoundingClientRect();
        const shown = this.cards.map((card, index) => ({ index, rect: card.getBoundingClientRect() }))
          .filter(item => item.rect.left >= bounds.left - 2 && item.rect.right <= bounds.right + 2);
        const first = shown.length ? shown[0].index : this.nearestCard();
        const last = shown.length ? shown[shown.length - 1].index : first;
        this.nav.querySelector('[data-look-position]').textContent = (first === last ? String(first + 1) : (first + 1) + '–' + (last + 1)) + ' / ' + this.cards.length;
        this.nav.querySelector('[data-look-nav="-1"]').disabled = this.grid.scrollLeft <= 2;
        this.nav.querySelector('[data-look-nav="1"]').disabled = this.grid.scrollLeft >= max - 2;
      }
      nearestCard() {
        const left = this.grid.getBoundingClientRect().left;
        let nearest = 0, distance = Infinity;
        this.cards.forEach((card, index) => {
          const delta = Math.abs(card.getBoundingClientRect().left - left);
          if (delta < distance) { distance = delta; nearest = index; }
        });
        return nearest;
      }
      moveLook(direction) {
        if (!this.cards.length) return;
        const step = this.cards.length > 1 ? this.cards[1].offsetLeft - this.cards[0].offsetLeft : this.grid.clientWidth;
        const perPage = Math.max(1, Math.floor((this.grid.clientWidth + 2) / this.cards[0].clientWidth));
        const next = Math.max(0, Math.min(this.grid.scrollWidth - this.grid.clientWidth, this.grid.scrollLeft + direction * step * perPage));
        this.grid.scrollTo({ left: next, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      }
      openLook(trigger) {
        if (this.submitting) return;
        this.trigger = trigger;
        const template = Array.from(this.querySelectorAll('[data-look-template]')).find(item => item.dataset.lookTemplate === trigger.dataset.lookOpen);
        if (!template) return;
        this.content.replaceChildren(template.content.cloneNode(true));
        const heading = this.content.querySelector('h2');
        this.dialog.setAttribute('aria-labelledby', heading.id);
        this.dialog.showModal();
        this.dialog.querySelector('.lb-looks__close').focus({ preventScroll: true });
        document.body.classList.add('lb-look-open');
        this.dialog.scrollTop = 0;
        this.updateTotal();
        this.refreshProducts();
      }
      rows() { return Array.from(this.content.querySelectorAll('[data-product-handle]')); }
      status(text) { this.content.querySelector('[data-look-status]').textContent = text; }
      updateTotal() {
        let total = 0;
        let count = 0;
        let incomplete = false;
        for (const row of this.rows()) {
          const include = row.querySelector('[data-look-include]');
          const select = row.querySelector('[data-look-size]');
          select.disabled = !include.checked || include.disabled;
          const choice = select.selectedOptions[0];
          const price = select.value ? Number(choice.dataset.price) : Number(row.dataset.minPrice);
          const compare = select.value ? Number(choice.dataset.compare || 0) : Number(row.dataset.minCompare || 0);
          row.querySelector('[data-item-price]').textContent = this.money.format(price / 100);
          const originalPrice = row.querySelector('[data-item-compare]');
          originalPrice.hidden = !(compare > price);
          originalPrice.textContent = compare > price ? this.money.format(compare / 100) : '';
          if (include.checked && !include.disabled) {
            total += price;
            count++;
            if (!select.value) incomplete = true;
          }
        }
        this.content.querySelector('[data-look-total]').textContent = this.money.format(total / 100);
        this.content.querySelector('[data-look-selection]').textContent = this.strings.selection.replace('{count}', count) + (incomplete ? ' · ' + this.strings.estimate : '');
      }
      async refreshProducts() {
        if (this.controller) this.controller.abort();
        const controller = new AbortController();
        this.controller = controller;
        this.refreshing = true;
        const timeout = setTimeout(() => controller.abort(), 12000);
        const rows = this.rows();
        const button = this.content.querySelector('[type=submit]');
        button.disabled = true;
        button.textContent = this.strings.checking;
        const root = this.dataset.root.endsWith('/') ? this.dataset.root : this.dataset.root + '/';
        const results = await Promise.allSettled(rows.map(async row => {
          const response = await fetch(root + 'products/' + encodeURIComponent(row.dataset.productHandle) + '.js', { signal: controller.signal, cache: 'no-store', headers: { Accept: 'application/json' } });
          if (!response.ok) throw new Error('Product unavailable');
          const product = await response.json();
          if (!Array.isArray(product.variants) || !product.variants.length) throw new Error('Product unavailable');
          return { row, product };
        }));
        clearTimeout(timeout);
        if (this.controller !== controller || !this.dialog.open || !this.isConnected) return;
        this.refreshing = false;
        let failed = false;
        for (const result of results) {
          if (result.status !== 'fulfilled') { failed = true; continue; }
          const { row, product } = result.value;
          const select = row.querySelector('[data-look-size]');
          const previous = select.value;
          select.replaceChildren(new Option(this.strings.choose, ''));
          const available = product.variants.filter(variant => variant.available);
          for (const variant of available) {
            const title = variant.title === 'Default Title' ? this.strings.oneSize : variant.title;
            const option = new Option(title, String(variant.id));
            option.dataset.price = variant.price;
            option.dataset.compare = variant.compare_at_price || 0;
            select.add(option);
          }
          const singleVariant = product.variants.length === 1 && product.options.length === 1;
          const fixedSize = singleVariant && ['default title', 'єдиний розмір', 'one size', 'one-size'].includes(product.variants[0].title.trim().toLowerCase());
          row.querySelector('[data-look-size-field]').hidden = fixedSize;
          if (available.some(variant => String(variant.id) === previous)) select.value = previous;
          else if (fixedSize && available.length === 1) select.value = String(available[0].id);
          const lowestVariant = available.reduce((lowest, variant) => !lowest || variant.price < lowest.price ? variant : lowest, null);
          row.dataset.minPrice = lowestVariant ? lowestVariant.price : product.price;
          row.dataset.minCompare = lowestVariant ? lowestVariant.compare_at_price || 0 : 0;
          const include = row.querySelector('[data-look-include]');
          include.disabled = !available.length;
          if (!available.length) include.checked = false;
          row.classList.toggle('is-unavailable', !available.length);
          row.querySelector('[data-item-stock]').hidden = !!available.length;
        }
        this.updateTotal();
        button.disabled = false;
        button.textContent = this.strings.add;
        if (failed) this.status(this.strings.refreshError);
      }
      async addItems(event) {
        event.preventDefault();
        if (this.submitting || this.refreshing) return;
        const selected = this.rows().filter(row => row.querySelector('[data-look-include]').checked && !row.querySelector('[data-look-include]').disabled);
        if (!selected.length) { this.status(this.strings.chooseItems); return; }
        const missing = selected.filter(row => {
          const select = row.querySelector('[data-look-size]');
          return !select.value || !select.selectedOptions[0] || select.selectedOptions[0].disabled;
        });
        if (missing.length) {
          for (const row of missing) row.querySelector('[data-look-size]').setAttribute('aria-invalid', 'true');
          this.status(this.strings.chooseSizes);
          missing[0].querySelector('[data-look-size]').focus();
          return;
        }
        const button = this.content.querySelector('[type=submit]');
        this.submitting = true;
        button.disabled = true;
        button.textContent = this.strings.adding;
        this.status('');
        const items = selected.map(row => ({ id: Number(row.querySelector('[data-look-size]').value), quantity: 1 }));
        try {
          const response = await fetch(this.dataset.addUrl.endsWith('.js') ? this.dataset.addUrl : this.dataset.addUrl + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }) });
          const result = await response.json();
          if (!response.ok || result.status) throw new Error('Cart could not add all items');
          this.status(this.strings.success);
          window.location.assign(this.dataset.cartUrl);
        } catch (error) {
          this.status(this.strings.addError);
          this.content.querySelector('[data-look-cart-link]').hidden = false;
          this.submitting = false;
          await this.refreshProducts();
          button.disabled = false;
          button.textContent = this.strings.add;
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
	class CartNote extends HTMLElement {
		constructor() {
			super();

			this.addEventListener(
				'change',
				debounce((event) => {
					const body = JSON.stringify({ note: event.target.value });
					fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
				}, 300)
			);
		}
	}

	customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
	class ProductModal extends ModalDialog {
		constructor() {
			super();
		}

		hide() {
			super.hide();
			window.pauseAllMedia();
		}

		show(opener) {
			super.show(opener);
			this.showActiveMedia();
		}

		showActiveMedia() {
			this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
					element.classList.remove('active');
				}
			)
			const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
			if (activeMedia) {
				activeMedia.classList.add('active');
				activeMedia.scrollIntoView();
			}
			
			if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMedia.querySelector('template')?.content?.querySelector('.js-youtube'))
				activeMedia.loadContent();
		}
	}

	class ProductRecommendations extends HTMLElement {
		constructor() {
			super();

			const handleIntersection = (entries, observer) => {
				if (!entries[0].isIntersecting) return;
				observer.unobserve(this);

				fetch(this.dataset.url)
					.then(response => response.text())
					.then(text => {
						const html = document.createElement('div');
						html.innerHTML = text;
						const recommendations = html.querySelector('product-recommendations--single');
						if (recommendations && recommendations.innerHTML.trim().length) {
							this.innerHTML = recommendations.innerHTML;
						}
					})
					.catch(e => {
						console.error(e);
					});
			}

			new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
		}
	}

	customElements.define('product-modal', ProductModal);
	customElements.define('product-recommendations--single', ProductRecommendations);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
	class ProductRecommendations extends HTMLElement {
		constructor() {
			super();

			const handleIntersection = (entries, observer) => {
				if (!entries[0].isIntersecting) return;
				observer.unobserve(this);

				fetch(this.dataset.url)
					.then((response) => response.text())
					.then((text) => {
						const html = document.createElement('div');
						html.innerHTML = text;
						const recommendations = html.querySelector(
							'product-recommendations'
						);
						if (recommendations && recommendations.innerHTML.trim().length) {
							this.innerHTML = recommendations.innerHTML;
						}
					})
					.catch((e) => {
						console.error(e);
					});
			};

			new IntersectionObserver(handleIntersection.bind(this), {
				rootMargin: '0px 0px 200px 0px',
			}).observe(this);
		}
	}

	customElements.define('product-recommendations', ProductRecommendations);
	

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["social-media-collage"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lb-deferred-video')) {
    customElements.define('lb-deferred-video', class extends HTMLElement {
      connectedCallback() {
        if (this.observer || this.loaded) return;
        if (window.Shopify?.designMode || !('IntersectionObserver' in window)) {
          this.loadVideo();
          return;
        }
        this.observer = new IntersectionObserver((entries) => {
          if (entries.some((entry) => entry.isIntersecting)) this.loadVideo();
        }, { rootMargin: '400px 0px' });
        this.observer.observe(this.closest('.social-media-collage__image-box') || this);
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        this.observer = null;
      }
      loadVideo() {
        if (this.loaded) return;
        const template = this.querySelector('template');
        if (!template) return;
        this.loaded = true;
        this.observer?.disconnect();
        const content = template.content.cloneNode(true);
        const video = content.querySelector('video');
        this.replaceWith(content);
        if (video) video.play().catch(() => { video.controls = true; });
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
